// Import model
import { StartFpRoomCreateRoomPhotoFileRequest } from '../models/StartFpRoomCreateRoomPhotoFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartFpRoomCreateRoomPhotoFileRequest - handles JSON serialization and deserialization with type validation
 */
export class StartFpRoomCreateRoomPhotoFileRequestSerializer {
  /**
   * Deserializes a JSON string into a StartFpRoomCreateRoomPhotoFileRequest instance
   */
  static deserialize(json: string): StartFpRoomCreateRoomPhotoFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartFpRoomCreateRoomPhotoFileRequest instance
   */
  static fromObject(obj: any): StartFpRoomCreateRoomPhotoFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartFpRoomCreateRoomPhotoFileRequest');
    }


    const instance: StartFpRoomCreateRoomPhotoFileRequest = {
      name: obj['Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartFpRoomCreateRoomPhotoFileRequest instances
   */
  static deserializeArray(json: string): StartFpRoomCreateRoomPhotoFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartFpRoomCreateRoomPhotoFileRequest instance to a JSON string
   */
  static serialize(instance: StartFpRoomCreateRoomPhotoFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartFpRoomCreateRoomPhotoFileRequest instance to a plain object
   */
  static toObject(instance: StartFpRoomCreateRoomPhotoFileRequest): any {
    return {
      'Name': instance.name,
    };
  }

  /**
   * Serializes an array of StartFpRoomCreateRoomPhotoFileRequest instances to a JSON string
   */
  static serializeArray(instances: StartFpRoomCreateRoomPhotoFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
